import React from 'react';

/**
 * Chips seleccionables del diálogo de saldo — `Club_MethodChip` y
 * `Club_QuickAmountChip` de Figma.
 *
 * Los dos comparten el mismo criterio y por eso viven juntos: el fondo es
 * SIEMPRE `secondary`, y lo único que cambia al seleccionar es el borde, que
 * pasa de `border` a `primary`. Antes el estado activo cambiaba el fondo a
 * blanco y añadía un anillo, así que se veía un doble contorno que no está en
 * el diseño.
 */

// `border-solid` va explícito: Tailwind lo pone en su preflight, pero Bulma se
// importa DESPUÉS y devuelve los <button> a `border-style: none`, así que el
// grosor se aplicaba y no se veía nada.
const BASE =
  'transition-colors disabled:cursor-not-allowed disabled:opacity-60 ' +
  'bg-[var(--muted)] rounded-sm border-solid';

const BORDER = (selected) =>
  selected
    ? 'border-selected border-[var(--primary)] text-[var(--foreground)]'
    : 'border border-[var(--border)] text-[var(--muted-foreground)] hover:border-[var(--muted-foreground)]';

/** Método de pago: icono arriba, etiqueta debajo. 120×56 en Figma. */
export function MethodChip({ icon: Icon, label, selected, onClick, disabled }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-pressed={selected}
      className={`${BASE} ${BORDER(selected)} flex h-14 flex-col items-center justify-center gap-1 text-xs font-medium`}
    >
      <Icon size={16} strokeWidth={1.5} aria-hidden />
      {label}
    </button>
  );
}

/** Importe rápido. 89×40 en Figma. */
export function QuickAmountChip({ value, selected, onClick, disabled }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-pressed={selected}
      className={`${BASE} ${BORDER(selected)} h-10 px-3 text-sm font-medium`}
    >
      {value} €
    </button>
  );
}

/** Título de sección de los diálogos: «MÉTODO DE PAGO», «CANTIDAD». */
export function FieldLabel({ children, htmlFor, className = '' }) {
  return (
    <label
      htmlFor={htmlFor}
      className={`block text-label font-medium uppercase text-[var(--muted-foreground)] ${className}`}
    >
      {children}
    </label>
  );
}
